import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLocationGraySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
      <circle cx={26} cy={21} r={6} fill="#fff" />
      <ellipse cx={25.714} cy={39.286} fill="#EEF0F2" rx={13.714} ry={4.714} />
      <path
        fill="#B4BECD"
        fillRule="evenodd"
        d="M25.714 8C18.14 8 12 13.708 12 20.75c0 4.385 2.318 8.44 4.882 11.603 2.58 3.184 5.528 5.608 7.035 6.759a2.98 2.98 0 0 0 3.594 0c1.508-1.15 4.455-3.575 7.036-6.759 2.564-3.163 4.882-7.218 4.882-11.603 0-7.042-6.14-12.75-13.715-12.75m-5.357 12.75c0-2.75 2.399-4.98 5.357-4.98s5.357 2.23 5.357 4.98-2.398 4.98-5.357 4.98-5.357-2.23-5.357-4.98"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLocationGraySmall);
export default ForwardRef;
